export default "__VITE_ASSET__CD3RTgrF__"